import * as React from 'react'

import { Box, Chevron, Text, Touchable } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import MinutesToText from 'modules/attendance/components/MinutesToText'

import AnimatedBox from '../../components/AnimatedBox'
import Breakdown from './Breakdown'

interface Props {
  estimatedMinutes: number
  estimatedMinutesForCurrentPeriod: number
  scheduledOvertimeMinutes: number
}

const Planned = ({
  estimatedMinutes,
  estimatedMinutesForCurrentPeriod,
  scheduledOvertimeMinutes,
}: Props) => {
  const [openPlannedBreakdown, setOpenPlannedBreakdown] = React.useState(false)

  return (
    <Box gap="s4">
      <Touchable onClick={() => setOpenPlannedBreakdown(!openPlannedBreakdown)}>
        <Box flexDirection="row" alignItems="center" justifyContent="spaceBetween" width="full">
          <Box flexDirection="row" justifyContent="spaceBetween" alignItems="center" gap="s16">
            <Box flexDirection="row" alignItems="center" gap="s6">
              <Chevron direction={openPlannedBreakdown ? 'up' : 'down'} type="terciary" />
              <Text size="300" weight="medium" color="grey1000">
                {i18n.t('clock_in.sidepanel.planned.title')}
              </Text>
            </Box>
          </Box>
          <MinutesToText color="grey1000" value={estimatedMinutes} size="300" weight="medium" />
        </Box>
      </Touchable>
      <AnimatedBox isOpen={openPlannedBreakdown}>
        <Breakdown
          estimatedMinutesForTheMonth={estimatedMinutesForCurrentPeriod}
          scheduledOvertimeMinutes={scheduledOvertimeMinutes}
        />
      </AnimatedBox>
    </Box>
  )
}

export default Planned
